import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {LegacyFeaturePill} from '../../../../../libs/shared/ui/src/components/pill/featurePill';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';

/*
 * Component.
 */

export const ReportHeaderLegacyPillWithTooltip: FC = () => (
  <TooltipCoordinator delay={0} render={() => ANALYTICS_DEPRECATED_IN_2025_TOOLTIP_CONTENT}>
    <LegacyFeaturePill />
  </TooltipCoordinator>
);

/*
 * Constants.
 */

export const ANALYTICS_DEPRECATED_IN_2025_TOOLTIP_CONTENT = (
  <Trans id="analytics-overview-legacy-tooltip">
    Limited support, will be deprecated in September 2025. Consider using the Workload report instead.
  </Trans>
);
